import { createRoot } from "react-dom/client"
import App from "@/app/entrypoint"

Number.prototype.pack = function () {
  return (this as number) < 10 ? `0${this}` : this.toString()
}
Number.prototype.display = function () {
  return new Intl.NumberFormat("en-US").format(this as number).replace(/,/g, " ")
}
Date.prototype.display = function (withTime = false) {
  const month = this.toLocaleDateString("ru-RU", { month: "long" })
  const date = `${this.getDate()} ${month} ${this.getFullYear()}`
  const time = `${this.getHours().toString().padStart(2, "0")}:${this.getMinutes().toString().padStart(2, "0")}`
  return withTime ? `${date}, ${time}` : date
}
Number.prototype.WSD = function () {
  return this.toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
    .replace(",", ".")
    .replace(/\s/g, " ")
}
Number.prototype.WS = function () {
  return this.toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

Date.prototype.MY = function () {
  if (Number.isNaN(this.getTime())) return "Invalid Date"
  const month = this.toLocaleDateString("ru-RU", { month: "long" })
  return `${month.charAt(0).toUpperCase() + month.slice(1)} ${this.getFullYear()}`
}
Date.prototype.YMD = function () {
  return `${this.getFullYear()}.${(this.getMonth() + 1).pack()}.${this.getDate().pack()}`
}
Date.prototype.YMDDASH = function () {
  return `${this.getFullYear()}-${(this.getMonth() + 1).pack()}-${this.getDate().pack()}`
}
Date.prototype.DMY = function () {
  return `${this.getDate().pack()}.${(this.getMonth() + 1).pack()}.${this.getFullYear()}`
}

Date.prototype.YMDHIS = function () {
  return `${this.YMD()} ${this.HIS()}`
}
Date.prototype.HIS = function () {
  return `${this.getHours().pack()}:${this.getMinutes().pack()}:${this.getSeconds().pack()}`
}
Date.prototype.HI = function () {
  return `${this.getHours().pack()}:${this.getMinutes().pack()}`
}

createRoot(document.getElementById("root")!).render(<App />)
